/**
 * 2019/4/4.
 * 作者:zhengyc
 * 功能: 定时任务
 */
export default {
  $getway: 'sysapi',
  getList: 'quartzConfig/list',
  getDetail: 'quartzConfig/detail',
  saveFn: 'quartzConfig/save',
  deleteFn: 'quartzConfig/delete',
  startUse: 'quartzConfig/startUse'
};
